import { formatINR, prettyDate } from './commerce';

const clean = (value, fallback = '-') => String(value || '').trim() || fallback;

export const buildWhatsAppUrl = (number, message) =>
  `https://wa.me/${String(number || '').replace(/\D/g, '')}?text=${encodeURIComponent(message)}`;

export const buildSingleOrderMessage = ({
  brandName,
  product,
  quantity,
  customer,
  fulfillment,
  neededBy,
  preferredTime,
  eggless,
  notes,
  pickupMessage
}) => {
  const itemTotal = product?.price == null ? null : product.price * quantity;
  const fulfillmentLines = fulfillment?.method === 'delivery'
    ? [
        'Method: Home delivery',
        `Area: ${clean(fulfillment.area)}`,
        `Full address: ${clean(fulfillment.address)}`
      ]
    : [`Method: ${pickupMessage}`];

  return [
    `Hi ${brandName}! I'd like to place an order.`,
    '',
    '*ORDER*',
    `Item: ${product?.name || 'Selected bake'} (${formatINR(product?.price)} each)`,
    `Quantity: ${quantity} ${quantity === 1 ? 'item' : 'items'}`,
    `Estimated item total: ${formatINR(itemTotal)}`,
    '',
    '*CUSTOMER*',
    `Name: ${clean(customer?.name, '—')}`,
    `Phone: ${clean(customer?.phone, '—')}`,
    '',
    '*FULFILMENT*',
    ...fulfillmentLines,
    `Needed by: ${prettyDate(neededBy)}`,
    `Preferred time: ${preferredTime || 'Flexible'}`,
    `Eggless where available: ${eggless ? 'Yes' : 'No preference'}`,
    `Notes: ${clean(notes, '—')}`
  ].join('\n');
};

export const buildCartOrderMessage = ({
  brandName,
  items,
  pricedTotal,
  quoteQuantity,
  customer,
  fulfillment,
  neededBy,
  preferredTime,
  eggless,
  notes,
  pickupMessage
}) => {
  const lines = items.map(({ product, qty, lineTotal }) => (
    product.price == null
      ? `* ${qty} x ${product.name} - price on request`
      : `* ${qty} x ${product.name} - ${formatINR(lineTotal)}`
  ));
  const summary = quoteQuantity > 0
    ? (pricedTotal > 0
        ? `Estimated total: ${formatINR(pricedTotal)} + ${quoteQuantity} quote ${quoteQuantity === 1 ? 'item' : 'items'}`
        : 'Pricing: Please share a quote')
    : `Estimated total: ${formatINR(pricedTotal)}`;
  const fulfillmentLines = fulfillment?.method === 'delivery'
    ? [
        'Method: Home delivery',
        `Area: ${clean(fulfillment.area)}`,
        `Full address: ${clean(fulfillment.address)}`
      ]
    : [`Method: ${pickupMessage}`];

  return [
    `Hi ${brandName}! I'd like to place an order:`,
    '',
    '*ORDER*',
    ...lines,
    '',
    summary,
    '',
    '*CUSTOMER*',
    `Name: ${clean(customer?.name)}`,
    `Phone: ${clean(customer?.phone)}`,
    '',
    '*FULFILMENT*',
    ...fulfillmentLines,
    `Needed by: ${prettyDate(neededBy)}`,
    `Preferred time: ${preferredTime || 'Flexible'}`,
    `Eggless where available: ${eggless ? 'Yes' : 'No preference'}`,
    `Notes: ${clean(notes)}`,
    '',
    'Please confirm availability, final pricing and delivery. Thank you!'
  ].join('\n');
};
